import { Droplets, Waves, Flame, Zap, Car, LucideIcon } from 'lucide-react';

export interface ProductInfo {
  type: string;
  name: string;
  pitch: string;
  detail: string;
  icon: LucideIcon;
  accent: string; // tailwind color token, e.g. 'cyan'
}

export const PRODUCT_CATALOG: ProductInfo[] = [
  {
    type: 'water',
    name: 'M3TRmon',
    pitch: 'Track water flow and catch leaks before they cost you.',
    detail: 'Measures live flow rate and totalizes consumption, so a running toilet or a burst pipe shows up on your dashboard within minutes instead of on your next bill.',
    icon: Droplets,
    accent: 'cyan',
  },
  {
    type: 'level',
    name: 'M3TRnivo',
    pitch: 'Know your tank level in real time — never run dry or overflow.',
    detail: 'Reads the water level in cisterns or tanks and alerts you on rapid drops or rises, so pump failures and overflows get caught immediately.',
    icon: Waves,
    accent: 'blue',
  },
  {
    type: 'gas',
    name: 'M3TRgas',
    pitch: 'Monitor LP gas levels and get low-tank alerts.',
    detail: 'Tracks LP gas tank level and temperature, warning you before a delivery is overdue.',
    icon: Flame,
    accent: 'orange',
  },
  {
    type: 'energy',
    name: 'XOCmon',
    pitch: 'See exactly where your electricity goes, channel by channel.',
    detail: 'Monitors up to 12 circuits plus solar generation, with per-channel energy breakdowns and voltage stats.',
    icon: Zap,
    accent: 'yellow',
  },
  {
    type: 'ev',
    name: 'XOCev',
    pitch: 'Smart EV charging that adapts to your home and solar.',
    detail: 'Charges your EV within your home\'s available capacity and solar surplus, with usage stats and budget tracking.',
    icon: Car,
    accent: 'emerald',
  },
];

export const getProductInfo = (type: string): ProductInfo | undefined =>
  PRODUCT_CATALOG.find(p => p.type === type);
